/* Beat Bagz — interim homepage scroll set pieces.
   Pattern docs: 07_Website/DESIGN_SPECS.md (Productivity workspace). */
(function () {
  'use strict';
  var reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Pattern A: translucent sleeve parallax ── */
  var sleeve = document.querySelector('[data-bbx-sleeve]');
  var revealSec = document.querySelector('[data-bbx-reveal]');
  if (sleeve && revealSec && !reduceMotion) {
    var ticking = false;
    var updateSleeve = function () {
      var r = revealSec.getBoundingClientRect();
      var total = r.height - innerHeight;
      var p = Math.min(1, Math.max(0, -r.top / total));
      var x = -0.3 * innerWidth + p * (1.45 * innerWidth);
      var rot = -8 + p * 16;
      sleeve.style.transform = 'translate(' + x + 'px, -50%) rotate(' + rot + 'deg)';
      ticking = false;
    };
    addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(updateSleeve); ticking = true; }
    }, { passive: true });
    updateSleeve();
  }

  /* ── Pattern B: ritual clock ── */
  var clockSec = document.querySelector('[data-bbx-clock-section]');
  var clockEl = document.querySelector('[data-bbx-clock]');
  if (clockSec && clockEl && !reduceMotion) {
    var timeEl = clockEl.querySelector('[data-bbx-clock-time]');
    var capEl = clockEl.querySelector('[data-bbx-clock-cap]');
    var labelEl = clockEl.querySelector('[data-bbx-clock-label]');
    var beats = JSON.parse(clockSec.getAttribute('data-bbx-beats') || '[]');
    var phase1Label = clockSec.getAttribute('data-bbx-label-1') || 'The reusable aftermath';
    var phase2Label = clockSec.getAttribute('data-bbx-label-2') || 'The Beat Bagz version';
    var phase2Time = clockSec.getAttribute('data-bbx-time-2') || '0:03';
    var phase2Cap = clockSec.getAttribute('data-bbx-cap-2') || 'Trash can. Done.';
    var lastCap = '';
    var fmt = function (m) {
      return Math.floor(m) + ':' + ('0' + Math.round((m % 1) * 60)).slice(-2);
    };
    var ticking2 = false;
    var updateClock = function () {
      var r = clockSec.getBoundingClientRect();
      var total = r.height - innerHeight;
      var p = Math.min(1, Math.max(0, -r.top / total));
      var cap;
      if (p < 0.72) {
        clockEl.classList.remove('bbx-dark');
        labelEl.textContent = phase1Label;
        timeEl.textContent = p < 0.58 ? fmt((p / 0.58) * 14) : '4–8 HRS';
        cap = beats.length ? beats[0][1] : '';
        for (var i = 0; i < beats.length; i++) if (p >= beats[i][0]) cap = beats[i][1];
      } else {
        clockEl.classList.add('bbx-dark');
        labelEl.textContent = phase2Label;
        timeEl.textContent = phase2Time;
        cap = phase2Cap;
      }
      if (cap !== lastCap) { capEl.textContent = cap; lastCap = cap; }
      ticking2 = false;
    };
    addEventListener('scroll', function () {
      if (!ticking2) { requestAnimationFrame(updateClock); ticking2 = true; }
    }, { passive: true });
    updateClock();
  }
  /* ── PDP: variant price sync + gallery thumbs ── */
  document.querySelectorAll('[data-bbx-pdp]').forEach(function (pdp) {
    var priceEl = pdp.querySelector('[data-bbx-price]');
    pdp.querySelectorAll('input[name="id"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (priceEl && radio.dataset.price) priceEl.textContent = radio.dataset.price;
      });
    });
    var main = pdp.querySelector('[data-bbx-main-img]');
    pdp.querySelectorAll('[data-bbx-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (main && btn.dataset.src) {
          main.src = btn.dataset.src;
          if (btn.dataset.srcset) main.srcset = btn.dataset.srcset; else main.removeAttribute('srcset');
        }
        pdp.querySelectorAll('[data-bbx-thumb]').forEach(function (b) { b.classList.remove('bbx-active'); });
        btn.classList.add('bbx-active');
      });
    });
  });
})();
